import { colors } from '@/styled/vars'
import styled from 'styled-components'

export const LogoIcon = styled.div`
  font-size: 40px;
  cursor: pointer;
`

export const LogoAccent = styled.span`
  color: ${colors.neon};
`
